import SlideBanners from "./SlideBanners";
import WMBanners from "./WMBanners";
import WMSwitcher from "./WMSwitcher";
import AdvantagesList from "./AdvantagesList";
import Shops from "./Shops";
import About from "../core/About";
import Subscribe from "../core/Subscribe";
import TileBanner from "./TileBanner";
import Advantages from "./Advantages";
import NowBuy from "./NowBuy";
import {useQuery} from "@tanstack/react-query";
import {mainPageData} from "../../api/page";
import {useEffect, useState} from "react";
import {getModelColorItems} from "../../api/catalog";
import {ModelGenderType} from "../../interfaces/model/ModelGenderInterface";
import HorizontalModelSlider from "./NowBuy";

export enum GenderType {
    MEN = "men",
    WOMEN = "women",
    ALL = "all",
}

export default function Main() {
    const [currentGender, setCurrentGender] = useState<GenderType>(GenderType.ALL);

    const {data: initData} = useQuery({
        queryKey: ['page', 'main'],
        queryFn: () => mainPageData()
    })

    const {data: nowBuyModelColorItemsData} = useQuery({
        queryKey: ['models-on-main', initData?.showOnMainRepositoryId],
        queryFn: () => getModelColorItems({
            repository_id: [initData?.showOnMainRepositoryId || ''],
            limit: 600,
            randomize: true
        }),
        enabled: !!initData?.showOnMainRepositoryId,
        retry: false
    })

    const getFilteredAndRandomizeModels = () => {
        let colorItems = (nowBuyModelColorItemsData?.model_color_items || []).sort(() => Math.random() - 0.5)

        return colorItems.sort(() => Math.random() - 0.5).filter(modelColorItem => {
            if(currentGender === GenderType.MEN){
                return modelColorItem.gender_id === ModelGenderType.MEN ||modelColorItem.gender_id === ModelGenderType.UNISEX
            }
            if(currentGender === GenderType.WOMEN){
                return modelColorItem.gender_id === ModelGenderType.WOMEN ||modelColorItem.gender_id === ModelGenderType.UNISEX
            }
            return true
        }).slice(0, 100)
    }

    const {model_color_items: nowBuyModelItems, meta: _} = nowBuyModelColorItemsData || {model_color_items: [], meta: undefined}

    return (
        <main className="main-index">
            {initData && <SlideBanners banners={initData.topBanners}/>}
            {initData && <WMBanners banners={initData.switchBanners}/>}
            <WMSwitcher currentGender={currentGender} setCurrentGender={setCurrentGender}/>

            {initData && initData.tileBanners.filter(banner => currentGender === GenderType.ALL || banner.gender === currentGender).map((banner, index) =>
                <section key={index} className={"collections " + (index > 0 ? 'collections--pb' : '')}><TileBanner
                    tileBanner={banner}/></section>)}
            {/*<ChooseYourLook/>*/}
            {initData && <Advantages bottomBanners={initData.bottomBanners}/>}
            {!!nowBuyModelColorItemsData?.model_color_items?.length && <HorizontalModelSlider modelColorItems={getFilteredAndRandomizeModels()} header={'Сейчас купили'}/>}

            <AdvantagesList/>
            <Shops/>
            <About/>
            <Subscribe/>
        </main>
    );
}